import { PLAYLIST } from "../../../config/audio/playlistConfig";
import { generateVolumeSteps } from "../../../config/audio/radioConfig";
import { Playlist, RadioState } from "../../../config/audio/types";
import { newPlaylist } from "../../../config/configHelpers";
import { shuffleArray } from "../immutableArray";

/**
 *
 * @param radio
 * @returns a new playlist containing all tracks associated with the radio
 */
export const createPlaylistFromState = (radio: RadioState): Playlist => {
	const audioTracks = PLAYLIST[radio.station].slice();
	const steps = generateVolumeSteps(radio.config);
	const effectiveGain = radio.gain * steps[radio.volumeLevel];
	return newPlaylist(audioTracks, effectiveGain, true, radio.station);
};

export const shuffleAudioTracksForPlaylist = (playlist: Playlist): Playlist => {
	const shuffledTracks = shuffleArray(playlist.playlist);
	return newPlaylist(shuffledTracks, playlist.gain, playlist.isLooping, playlist.name);
};
